/* eslint-disable @bigbinary/neeto/use-neetoui-classes */
import { Popover, Typography } from "@bigbinary/neeto-atoms";
import classNames from "classnames";
import { CircleHelp } from "lucide-react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { SIZE } from "./constants";

const HelpPopover = ({
  title,
  size = "large",
  description,
  helpLinkProps,
  className,
  iconColor = "currentColor",
  icon: IconComponent = CircleHelp,
  side,
  sideOffset,
  align,
  alignOffset,
}) => {
  const { t } = useTranslation();

  const position = align && align !== "center" ? `${side}-${align}` : side;

  return (
    <Popover
      {...{ alignOffset, position, sideOffset }}
      closeDelay={150}
      openDelay={0}
      trigger={
        <button
          data-testid="help-popover-button"
          type="button"
          className={classNames(
            "inline-flex cursor-pointer items-center justify-center rounded-full border-none bg-transparent p-0",
            className
          )}
        >
          <IconComponent color={iconColor} size={SIZE[size]} />
        </button>
      }
    >
      <div className="flex flex-col" onClick={event => event.stopPropagation()}>
        {title && (
          <Typography asChild variant="body2" weight="semibold">
            <h3 className="mb-2" data-testid="help-popover-title">
              {title}
            </h3>
          </Typography>
        )}
        {typeof description === "string" ? (
          <Typography
            color="muted"
            data-testid="help-popover-description"
            variant="body2"
          >
            {description}
          </Typography>
        ) : (
          description
        )}
        {helpLinkProps &&
          (() => {
            const { label: linkLabel, ...restLinkProps } = helpLinkProps;

            return (
              <a
                className="text-primary mt-3 text-sm hover:underline"
                data-testid="help-popover-link-button"
                rel="noreferrer"
                target="_blank"
                {...restLinkProps}
              >
                {linkLabel ?? t("neetoMolecules.common.viewHelpArticle")}
              </a>
            );
          })()}
      </div>
    </Popover>
  );
};

HelpPopover.propTypes = {
  title: PropTypes.string,
  size: PropTypes.oneOf(["default", "large"]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  helpLinkProps: PropTypes.object,
  className: PropTypes.string,
  iconColor: PropTypes.string,
  icon: PropTypes.node,
  side: PropTypes.oneOf(["top", "right", "bottom", "left"]),
  sideOffset: PropTypes.number,
  align: PropTypes.oneOf(["start", "center", "end"]),
  alignOffset: PropTypes.number,
};

export default HelpPopover;
